import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { DtGrid2 } from "../common/DtGrid2";
import { getConsumptionDefaultColumns } from "./ConsumptionDefaultColumns";
import {
    clearActivityErrorRedux,
    clearAssignedLineIdRedux,
    clearConsRedux,
    closeConsRedux,
    getActConsRedux
} from "../../redux/slices/activity.feature";
import ConsumptionDefaultRightClick from "./ConsumptionDefaultRightClick";
import ConsumptionDefaultBottomButtons from "./ConsumptionDefaultBottomButtons";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { getActivityActiveButtons } from "../../aplUtils/permissions";
import { bootboxAlert, bootboxConfirm } from "../common/bootboxWrapper";
import { Activity } from "../../types/activity";
import { DtGridPropsOptions2 } from "../../types/dtGridPropsOptions2";
import { ConsumptionDefaultBottomButtonsProps } from "../../types/consumptionDefaultBottomButtonsProps";
import { useTranslation } from "react-i18next";
import { getExceptionText, translateColumns, translateString } from "../../translations/gridTranslationHelper";
import { getTextColor } from "../../aplUtils/themeHelper";

const ConsumptionDefault = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const aplSettings = AplSettingsSelector();
    const navigate = useNavigate();
    // document.title = `APLV3 ${t("main.rxg_Consumption")}`;

    useEffect(() => {
        dispatch(clearConsRedux());
        dispatch(getActConsRedux({ siteId: aplSettings.siteId, departmentId: aplSettings.departmentId }));
    }, [dispatch, aplSettings.siteId, aplSettings.departmentId]);

    const [selectedItem, setSelectedItem] = useState([] as Activity[]);
    const [page, setPage] = React.useState<number>(1);

    const dtGridOptns: DtGridPropsOptions2 = {
        data: aplSettings.activity.actCons,
        loading: aplSettings.activity.actConsLoading,
        columnData: translateColumns(getConsumptionDefaultColumns(aplSettings.site, aplSettings.culture), aplSettings.culture),
        selectType: "single",
        colouring: true,
        headerFilters: false,
        setSelectedItems: function (x: Activity[]) {
            setSelectedItem(x);
        },
        selectedItems: selectedItem,
        tableName: "tblCons",
        paging: false,
        showSpinner: !aplSettings.activity.actConsFirstLoaded,
        rowId: "lineId",
        defaultSort: {
            field: ["lineId"],
            direction: ["asc"]
        },
        tableClass: "table-consumption-default",
        pageLength: 20,
        filters: {},
        setFilters: () => {},
        refreshSelectedOnDataChange: true,
        page: page,
        setPage: setPage
    };

    React.useEffect(() => {
        if (aplSettings.activity.actConsClosedLineId) {
            bootboxConfirm(translateString("doYouWantToActivate", aplSettings.culture), null, (resp: boolean) => {
                if (resp) navigate(`/assigncons/${aplSettings.activity.actConsClosedLineId}`);
            });
            dispatch(clearAssignedLineIdRedux());
        }
    }, [aplSettings.activity.actConsClosedLineId, dispatch, navigate, aplSettings.culture]);

    React.useEffect(() => {
        if (aplSettings.activity.actConsError) {
            bootboxAlert(getExceptionText(aplSettings.activity.actConsError, aplSettings.culture), () => {
                dispatch(clearActivityErrorRedux());
            });
        }
    }, [aplSettings.activity.actConsError, aplSettings.culture, dispatch]);

    const getButtonsOptions = (): ConsumptionDefaultBottomButtonsProps => {
        let opts = getActivityActiveButtons(selectedItem);

        return {
            ...opts,
            consumptionOnlineFunc: () => {
                navigate(`/consumption/${selectedItem[0].lineId}`);
            },
            consumptionOfflineFunc: () => {
                navigate(`/consumption/${selectedItem[0].lineId}/${selectedItem[0].operationId}`);
            },
            workorderEnquiryFunc: () => {
                navigate(`/workordermanagement`);
            },
            jobAssignFunc: () => {
                navigate(`/assigncons/${selectedItem[0].lineId}`);
            },
            jobCloseFunc: () => {
                bootboxConfirm(t("main.areyousureyouwanttoclosethejob"), null, async (resp: boolean) => {
                    if (resp) dispatch(closeConsRedux(selectedItem[0]) as any);
                });
            }
        };
    };

    return (
        <React.Fragment>
            <div id="div-error" className={`alert alert-danger ${aplSettings.activity.actConsError ? "" : "hide"}`} role="alert">
                {getExceptionText(aplSettings.activity.actConsError, aplSettings.culture)}
            </div>

            <div className="container mw-100">
                <div className="row">
                    <div className="col">
                        <h2
                            className="rounded-lg pl-2"
                            style={{
                                backgroundColor: aplSettings.theme.consumptionColour ? aplSettings.theme.consumptionColour : "inherit",
                                color: aplSettings.theme.consumptionColour ? getTextColor(aplSettings.theme.consumptionColour) : "inherit"
                            }}
                        >
                            {t("main.rxg_Consumption")}
                        </h2>
                        <DtGrid2 options={dtGridOptns}>
                            <ConsumptionDefaultRightClick {...getButtonsOptions()} />
                            <ConsumptionDefaultBottomButtons {...getButtonsOptions()} />
                        </DtGrid2>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ConsumptionDefault;
